import { createContext, useContext, useRef } from "react";

const SpreadWrapperContext = createContext<any>(null);

export const useSpreadWrapper = () => {
  return useContext(SpreadWrapperContext);
};

export const SpreadWrapperProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const spreadWrapperRef = useRef<any>(null);

  return (
    <SpreadWrapperContext.Provider value={{ spreadWrapperRef }}>
      {children}
    </SpreadWrapperContext.Provider>
  );
};
